import { object } from '@calendly/form/validation'
import { useSelector } from 'react-redux'

import { getPaymentsValidationSchema, BILLING_FEATURE_KEY, preparePaymentsValuesForPreview } from 'components/event_type_edit'
import { isRestrictedFeatureSelector } from 'features/billing'

export const getInitialValues = (eventType) => {
  const paymentMethod = eventType.payment_method || {}
  const amountCents = Number(paymentMethod.amount_cents || 0)

  return {
    paymentId: paymentMethod.id,
    provider: (paymentMethod.enabled && paymentMethod.provider) || 'none',
    currency: paymentMethod.currency || 'USD',
    amount: amountCents / 100,
    paymentTerms: paymentMethod.payment_terms || ''
  }
}

export const usePrepareValuesForPreview = () => {
  const isUpgradeRequired = useSelector((state) => isRestrictedFeatureSelector(state, { featureKey: BILLING_FEATURE_KEY }))

  return (eventType, formValues) => preparePaymentsValuesForPreview(eventType, formValues, isUpgradeRequired)
}

export const getFormatValuesToServerData = (eventType) => (values) => {
  const { paymentId, provider, amount, currency, paymentTerms } = values
  const lastPaymentMethod = eventType.payment_method || {}
  const lastValidProvider = lastPaymentMethod.provider || 'stripe'

  return {
    payment_method_attributes: {
      id: paymentId,
      provider: provider === 'none' ? lastValidProvider : provider,
      amount: provider === 'none' && !amount ? null : amount,
      currency,
      payment_terms: paymentTerms,
      enabled: provider !== 'none',
    }
  }
}

export const getValidationSchema = () => object({})
  .concat(getPaymentsValidationSchema())
